import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {toast} from "react-toastify";
import LicenseService from "../../shared/service/LicenseService";
import {Checkbox} from "primereact/checkbox";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";
import LicenseColumn from "../../shared/component/dataTable/columns/LicenseColumn.json";
import Dialog from "../../shared/component/dialog/Dialog";
import AppLicenseAndCredentialsSave from "./AppLicenseAndCredentialsSave";
import '../../shared/styles/SettingsPage.css';

const defaultLicense = {
    id: null,
    licenseStatus: '',
    merchantBranchId: '',
    notes: '',
    eft: false,
    creditAddress: null,
    creditAddressUsed: null,
    creditDistance: null,
    creditDistanceUsed: null,
    appLicencesEntityList: []
};
export default class BranchLicenseSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            license: Object.assign({}, defaultLicense),
            licenseTemp: Object.assign({}, defaultLicense),
            pageMode: null
        }
        this.licenseService = new LicenseService();
    }

    render() {
        return (
            <div className="settings-page settings-page--embedded">

                <Row>
                    <Col md="2">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate
                                    contentKey="merchantBranch.tradingName">Credit Address</Translate>
                            </Label>

                            <AvField
                                type="number"
                                value={this.state.license.creditAddress}
                                disabled={!this.state.licenseSaveButtonRender}
                                name="creditAddress"
                                min={100} max={1000000}
                                className="input-group"
                                onChange={this.__handleChange}
                                showButtons/>


                        </AvGroup>
                    </Col>

                    <Col md="2">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate
                                    contentKey="merchantBranch.tradingName">Credit Distance</Translate>
                            </Label>

                            <AvField
                                type="number"
                                value={this.state.license.creditDistance}
                                disabled={!this.state.licenseSaveButtonRender}
                                name="creditDistance"
                                min={100} max={1000000}
                                className="input-group"
                                onChange={this.__handleChange}
                                showButtons/>


                        </AvGroup>
                    </Col>


                    <Col md="2">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate
                                    contentKey="merchantBranch.tradingName">Credit Distance Used</Translate>
                            </Label>

                            <AvField
                                type="number"
                                value={this.state.license.creditDistanceUsed}
                                disabled={true}
                                name="creditDistanceUsed"
                                min={100} max={1000000}
                                className="input-group"
                                onChange={this.__handleChange}
                                showButtons/>


                        </AvGroup>
                    </Col>

                    <Col md="2">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate
                                    contentKey="merchantBranch.tradingName">Credit Address Used</Translate>
                            </Label>

                            <AvField
                                type="number"
                                value={this.state.license.creditAddressUsed}
                                disabled={true}
                                name="creditAddressUsed"
                                min={100} max={1000000}
                                className="input-group"
                                onChange={this.__handleChange}
                                showButtons/>


                        </AvGroup>
                    </Col>


                    <Col md="2">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate
                                    contentKey="merchantBranch.tradingName">Notes</Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="notes"
                                disabled={!this.state.licenseSaveButtonRender}
                                validate={{
                                    maxLength: {
                                        value: 255,
                                        errorMessage: "You can enter up to 255 characters in this field."
                                    }
                                }}
                                value={this.state.license.notes}
                                onChange={this.__handleChange}/>
                        </AvGroup>


                    </Col>
                    <Col md="2">
                        <AvGroup>
                            <Label for="eft">
                                <Translate contentKey="eft">Eft&nbsp;</Translate>
                            </Label>

                            <Checkbox onChange={(e) => this.setChecked("eft", e.checked)}
                                      name="eft"
                                      disabled={!this.state.licenseSaveButtonRender}
                                      value={this.state.license.eft}
                                      checked={this.state.license.eft}></Checkbox>


                        </AvGroup>
                    </Col>
                </Row>


                <div className="settings-page__actions settings-page__actions--compact settings-page__branch-license-actions">
                    {!this.state.licenseSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({licenseSaveButtonRender: true});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}
                    {this.state.licenseSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveLicense();
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }
                </div>

                <div className="settings-page__branch-license-app">
                    <h3 className="settings-page__form-section-title">App License</h3>
                    <div className="settings-page__actions settings-page__actions--compact settings-page__branch-license-actions">
                    <Button color="outline-primary" className="settings-page__btn--add" onClick={() => {
                        GeneralUtils.openDialogThenRef(this, {displayDialog: true, selectedAppLicense: null}, () => this.refModelSave, (ref) => {
                            ref.licenseSaveButtonRender();
                            ref.clearData();
                        });
                    }}>
                        <Translate contentKey="entity.action.add">Add</Translate>
                    </Button>
                    </div>

                    <DataTableAll ref={(elem) => this.refModelLicenseSave = elem}
                                  fields={LicenseColumn.fields}
                                  objectName={LicenseColumn.name}
                                  data={this.state.license.appLicencesEntityList}
                                  rows={10}
                                  paginator={true}
                                  selectionMode="single" onDataSelect={this.onDataSelect}
                    />

                    <Dialog visible={this.state.displayDialog}
                            header={"License"}
                            onHide={() => this.setState({displayDialog: false})}
                            style={{width: '80vw', height: '45vw'}}>

                        <AppLicenseAndCredentialsSave
                            refreshDataTable={this.refreshDataTable}
                            ref={(elem) => this.refModelSave = elem}
                            closeDisplayDialog={this.closeDisplayDialog}
                            appLicense={this.state.selectedAppLicense}
                            getMerchantBranchId={this.getMerchantBranchId}
                            deleteAppLicense={(id) => {
                                this.licenseService.deleteApplicence(id)
                                    .then((response) => {
                                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                            this.setState({
                                                licenseSaveButtonRender: false

                                            });
                                            this.props.refreshDataTable();
                                            this.closeDisplayDialog();
                                        }
                                    });


                            }}
                            saveAppLicense={(row) => {
                                if (row.id) {
                                    let license = this.state.license;
                                    const foundObject = license.appLicencesEntityList.find(item => item.id === row.id);
                                    Object.assign(foundObject, row);
                                    this.setState({license: license});
                                    this.saveLicense(license);
                                } else {
                                    let result = this.checkLicenses(row);
                                    if (result) {
                                        return toast.warn("Maximum one service name  per branch except 'Artpos'");
                                    } else {
                                        let license = this.state.license;
                                        license.appLicencesEntityList.push(row)
                                        this.setState({license: license});
                                        this.saveLicense(license);
                                    }

                                }
                                this.closeDisplayDialog();
                            }}
                        />
                    </Dialog>

                </div>


            </div>
        );
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {
            selectedAppLicense: data,
            displayDialog: true
        }, () => this.refModelSave, (ref) => ref.setData(Object.assign({}, data)));
    }

    checkLicenses = (row) => {
        let license = this.state.license;
        var count = 0;
        if (license.appLicencesEntityList != null) {
            for (var i = 0; i < license.appLicencesEntityList.length; i++) {
                if (license.appLicencesEntityList[i].serviceName == row.serviceName && row.serviceName != "ARTPOS") {
                    count++;
                }
            }
        }

        return count > 0 ? true : false;

    }

    setChecked = (name, value) => {
        let license = this.state.license;
        license[name] = value;
        this.setState({license: license});
    }

    getMerchantBranchId = () => {
        return this.props.getMerchantBranchId();
    }
    saveLicense = () => {
        let license = this.state.license;
        license["merchantBranchId"] = this.props.getMerchantBranchId();
        this.setState({license: license});

        if (!GeneralUtils.isNullOrEmpty(this.state.license.id)) {
            this.licenseService.update(this.state.license)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {

                        this.setState({
                            license: response,
                            licenseTemp: Object.assign({}, response),
                            licenseSaveButtonRender: false
                        })
                        this.props.refreshDataTable();

                    }
                });
        } else {
            this.licenseService.create(this.state.license)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {

                        this.setState({
                            license: response,
                            licenseTemp: Object.assign({}, response),
                            licenseSaveButtonRender: false
                        })
                        this.props.refreshDataTable();

                    }
                });
        }

    }

    setData = (data) => {
        this.setState({license: data, licenseTemp: Object.assign({}, data),});
    }

    clearData = () => {
        let obj = Object.assign({}, defaultLicense);
        this.setState({license: obj});
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let license = this.state.license;
        license[e.target.name] = value;
        this.setState({license: license});
    }

}

BranchLicenseSave.propTypes = {
    license: PropTypes.object
};
